module.exports = __webpack_public_path__ + "flakes.jpg?c96e57a0a38cd978e7887cef8a7f1694";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flakes.jpg
// module id = 192
// module chunks = 0